import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, fromEvent, Observable, Subject } from 'rxjs';
import {
  Area,
  AuthService,
  ChecklistItem,
  GeographicalRegion,
  GeographicalRegionService,
  KeyValueItem,
  PermissionsEnum,
  PermissionsService,
  SubGeographicalRegion,
  SubGeographicalRegionService,
  UserForFilter,
  UserType,
} from 'shared-lib';
import {
  AssignStatus,
  KycSubServiceType,
} from 'src/app/_modules/customers/_models/kyc-account-data';
import { CustomerStatsOptions } from 'src/app/enums/customer-stats-options.enum';
import {
  AccountKycList,
  KycDownloadReportType,
} from 'src/app/models/accountKyc.model';
import {
  AssetStatus,
  BuildingType,
  FilterByOptions,
  InstallationAndPowerSource,
  ServiceType,
  SortByOptions,
} from 'src/app/models/customer.model';
import { NewServiceStats } from 'src/app/models/new-service-stats.model';
import { ProjectDesignationDto } from 'src/app/models/projectDesignation.model';
import { OrganizationMultiSelect } from 'src/app/models/organization.model';
import { Region } from 'src/app/models/region.model';
import { ProjectType } from 'src/app/models/serviceConnection.model';
import { Tariff } from 'src/app/models/tariff.model';
import { AreaService } from 'src/app/services/area.service';
import { CustomerService } from 'src/app/services/customer.service';
import { AccountKycService } from 'src/app/services/kyc/account-kyc.service';
import { ProjectDesignationService } from 'src/app/services/project-designation.service';
import { OrganizationTeamApiService } from 'src/app/services/organization-team-api.service';
import { RegionService } from 'src/app/services/region.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-new-connection-and-onboarder-list',
  templateUrl: './new-connection-and-onboarder-list.component.html',
  styleUrls: ['./new-connection-and-onboarder-list.component.scss'],
})
export class NewConnectionAndOnboarderListComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() activeTab: number;

  customerStats: NewServiceStats;
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  routerLink: string;
  tag?: number;
  tagOptions = [
    { name: 'Existing', value: 0, translation: 'COMMON.TAG.EXISTING' },
    { name: 'New entry', value: 1, translation: 'COMMON.TAG.NEW_ENTRY' },
  ];
  status?: number;
  statusOptions = [
    {
      name: 'Pending',
      value: AssetStatus.Pending,
      translation: 'COMMON.ASSET_STATUS.PENDING',
    },
    {
      name: 'Complete',
      value: AssetStatus.Complete,
      translation: 'COMMON.ASSET_STATUS.COMPLETE',
    },
    {
      name: 'Rejected',
      value: AssetStatus.Rejected,
      translation: 'COMMON.ASSET_STATUS.REJECTED',
    },
    {
      name: 'Assigned',
      value: AssetStatus.Assigned,
      translation: 'COMMON.ASSET_STATUS.ASSIGNED',
    },
  ];
  userType?: number;
  userTypeOptions = [
    {
      name: 'First Captured User',
      value: UserType.FirstCapturedUser,
      translation: 'COMMON.USER.TYPE.FIRST_CAPTURED',
    },
    {
      name: 'Last Captured User',
      value: UserType.LastCapturedUser,
      translation: 'COMMON.USER.TYPE.LAST_CAPTURED',
    },
    {
      name: 'Reassigned By',
      value: UserType.ReassignedBy,
      translation: 'COMMON.USER.TYPE.REASSIGNED',
    },
    {
      name: 'Validated By',
      value: UserType.ValidatedBy,
      translation: 'COMMON.USER.TYPE.VALIDATED',
    },
    {
      name: 'Audited By',
      value: UserType.AuditedBy,
      translation: 'COMMON.USER.TYPE.AUDITED',
    },
  ];
  serviceType?: number;
  serviceTypeOptions = [
    {
      name: 'First Captured User',
      value: ServiceType.Large,
      translation: 'COMMON.SERVICE_TYPE.LARGE',
    },
    {
      name: 'Last Captured User',
      value: ServiceType.Small,
      translation: 'COMMON.SERVICE_TYPE.SMALL',
    },
    {
      name: 'Reassigned By',
      value: ServiceType.Prepaid,
      translation: 'COMMON.SERVICE_TYPE.PREPAID',
    },
    {
      name: 'Validated By',
      value: ServiceType.AMR,
      translation: 'COMMON.SERVICE_TYPE.AMR',
    },
    {
      name: 'Audited By',
      value: ServiceType.AMR,
      translation: 'COMMON.SERVICE_TYPE.AMR',
    },
  ];
  searchByOptions = [
    {
      name: 12,
      value: 'Application No.',
      translation: 'COMMON.TABLE_HEADERS.APP_NUM',
    },
    {
      name: 1,
      value: 'Account No.',
      translation: 'CUSTOMERS.SEARCH_BY.ACCOUNT_NO',
    },
    { name: 11, value: 'SPN', translation: 'COMMON.CONTRACT_NUMBER' },
  ];
  dateTypes = [
    {
      name: 'LastUpdateTime',
      value: 'Last Update Time',
      translation: 'COMMON.DATE_TYPE.LAST_UPDATE',
    },
    {
      name: 'TaggedDate',
      value: 'Tagged Date',
      translation: 'COMMON.DATE_TYPE.TAGGED',
    },
    {
      name: 'ValidatedDate',
      value: 'Validated Date',
      translation: 'COMMON.DATE_TYPE.VALIDATED',
    },
  ];
  kycTagOptions = [
    { name: 'Existing', value: 0, translation: 'COMMON.TAG.EXISTING' },
    { name: 'New Customer', value: 1, translation: 'COMMON.TAG.NEW_CUSTOMER' },
  ];
  kycStatus?: number;
  kycStatusOptions = [
    {
      name: 'Pending',
      value: 1,
      translation: 'COMMON.KYC_STATUS_OPTIONS.PENDING',
    },
    {
      name: 'Rejected',
      value: 2,
      translation: 'COMMON.KYC_STATUS_OPTIONS.REJECTED',
    },
    {
      name: 'In Progress',
      value: 3,
      translation: 'COMMON.KYC_STATUS_OPTIONS.INPROGRESS',
    },
    {
      name: 'Approved',
      value: 4,
      translation: 'COMMON.KYC_STATUS_OPTIONS.APPROVED',
    },
    {
      name: 'Suspended',
      value: 5,
      translation: 'COMMON.KYC_STATUS_OPTIONS.SUSPENDED',
    },
  ];
  uopOptions = [
    {
      name: 'Residential',
      translation: 'COMMON.BUILDING_TYPE.RESIDENTIAL',
      value: BuildingType.Residential,
    },
    {
      name: 'Commercial',
      translation: 'COMMON.BUILDING_TYPE.COMMERCIAL',
      value: BuildingType.Commercial,
    },
    {
      name: 'Industrial',
      translation: 'COMMON.BUILDING_TYPE.INDUSTRIAL',
      value: BuildingType.Industrial,
    },
    {
      name: 'Mixed',
      translation: 'COMMON.BUILDING_TYPE.MIXED',
      value: BuildingType.Mixed,
    },
    {
      name: 'Religious Center',
      translation: 'COMMON.BUILDING_TYPE.RELIGIOUSHOUSE',
      value: BuildingType.ReligiousCenter,
    },
  ];
  mobileUserType: UserType[] = [
    UserType.FirstCapturedUser,
    UserType.LastCapturedUser,
  ];
  adminUserType: UserType[] = [
    UserType.ValidatedBy,
    UserType.ReassignedBy,
    UserType.AuditedBy,
  ];

  sltOptions: {
    id: number;
    displayValue: string;
    installationAndPowerSource: number;
  }[] = [];

  selectedSubserviceType?: number;
  showSubserviceTypes: boolean = false;
  subServiceTypeOptions: { value: number; displayValue: string }[] = [
    { value: KycSubServiceType.PublicLoad, displayValue: 'Public Load' },
    {
      value: KycSubServiceType.MeterReplacement,
      displayValue: 'Meter Replacement',
    },
    { value: KycSubServiceType.Migration, displayValue: 'Migration' },
    { value: KycSubServiceType.Separation, displayValue: 'Separation' },
    {
      value: KycSubServiceType.PointLoadTransformer,
      displayValue: 'Point Load Transformer',
    },
    {
      value: KycSubServiceType.DedicatedFeeder,
      displayValue: 'Dedicated Feeder',
    },
    { value: KycSubServiceType.NewService, displayValue: 'New Service' },
    { value: KycSubServiceType.UpgradeToKcg, displayValue: 'Upgrade to KCG' },
  ];

  sltStatusName: string =
    this.translationService.getByKeyFromStorage('SltStatus');
  showUpload: boolean = false;
  showBulkVendorUpload: boolean = false;
  showSortBy: boolean = false;
  ddPos = { top: '0px', left: '0px' };
  mapSortBy: Record<number, any> = {
    [SortByOptions.NEWEST]: {
      label: 'Newest',
      translation: 'COMMON.SORT_BY.NEWEST',
      arrow: 'no',
    },
    [SortByOptions.OLDEST]: {
      label: 'Oldest',
      translation: 'COMMON.SORT_BY.OLDEST',
      arrow: 'no',
    },
  };

  selectedFilters: ChecklistItem[] = [];
  isServiceTypeFieldVisible: boolean = true;
  useOfPremises?: number;
  kycTag?: number;

  //tab counts
  count: number = 2;
  stats: KeyValueItem[] = [];

  isRegularizationUploadVisible: boolean = true;
  withAccNoSelected = 0;

  pageSize: number = 10;
  currentPage: number = 1;
  currentTab: number = 1;
  currentTabName: string = 'Service Request';

  searchText: string = '';
  searchFilterApplied: boolean = false;
  searchTextUpdate = new Subject<string>();

  showSelectSearchType: boolean = false;
  selectedSearchType: number;
  selectedSearchTypeDisplay: string;
  selectedDateType: string;
  selectedDateTypeDisplay: string;
  showSelectDateType: boolean = false;

  customerType: number = 0;
  showFilterBy: boolean = false;
  clicked: boolean = false;
  utilityId: number = 0;
  reset: boolean = false;

  dateFrom: string;
  dateTo: string;

  sortByValue: SortByOptions = SortByOptions.NEWEST;
  sortByOptions = SortByOptions;
  sortByLabelValue: any = this.mapSortBy[SortByOptions.NEWEST];
  filterByOptions = FilterByOptions;
  filterByValue?: FilterByOptions = FilterByOptions.ONBOARDED;

  usersFilter: any; // Stores value of filter
  mobileUsers: UserForFilter[] = []; // Store only mobile users
  adminUsers: UserForFilter[] = []; // Store only admin users
  allUsers: UserForFilter[] = []; // Store mobile or admin users depending on filter
  filteredUsers: UserForFilter[] = []; // Used for display and for filtering users list
  selectedUsers: number[] = [];

  regions: Region[] = [];
  areas: Area[] = [];
  allAreas: Area[] = [];
  geographicalRegions: (GeographicalRegion & { checked?: boolean })[] = [];
  allSubGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  subGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  tariff: number = 0;
  tariffs: Tariff[] = [];
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedSubGeographicalRegions: number[] = [];

  hasCimDataIntegration: boolean = false;

  currency: string = '';
  allCheckboxesChecked: boolean = false;
  accountKycs: AccountKycList[] = [];
  KycDownloadReportType = KycDownloadReportType;
  selectedKycDownloadReportType?: KycDownloadReportType | null = null;
  showDownload: boolean = false;

  projectDesignations: ProjectDesignationDto[] = [];
  selectedProjectDesignationIds: number[] = [];

  selectedSltStatus?: number;
  isSltDropdownDisabled: boolean = false;
  selectedProjectTypes: number[] = [];
  projectTypeOptions: {
    value: number;
    name: string;
    checked: boolean;
  }[] = [
    { value: ProjectType.MAP, name: 'MAP', checked: false },
    { value: ProjectType.NMAP, name: 'NMAP', checked: false },
    { value: ProjectType.KCG, name: 'KCG', checked: false },
  ];

  selectedAssignStatus?: number;

  assignStatusOptions: { value: number; displayValue: string }[] = [
    { value: AssignStatus.Assigned, displayValue: 'Assigned' },
    { value: AssignStatus.NotAssigned, displayValue: 'Not Assigned' },
  ];

  clickObservable: Observable<Event> = fromEvent(document, 'click');

  selectedOrganizations: number[] = [];
  organizations: OrganizationMultiSelect[] = [];

  private ngUnsubscribe = new Subject<void>();
  @ViewChild('downloadWrapper') downloadWrapper!: ElementRef;

  constructor(
    private toastr: ToastrService,
    private translationService: TranslationService,
    private kycAccountService: AccountKycService,
    private customerService: CustomerService,
    private regionService: RegionService,
    private areaService: AreaService,
    private organizationTeamService: OrganizationTeamApiService,
    private projectDesignationService: ProjectDesignationService,
    public permissionsService: PermissionsService,
    private authService: AuthService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService,
  ) {
 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeTab']) {
      this.searchText = '';
      this.routerLink =
        this.activeTab == 4
          ? 'onboarded-customer-details'
          : 'new-service-details';
      this.resetFilter(false, this.activeTab != 4);
      if (changes['activeTab'].previousValue) {
        this.reloadTable();
        this.getOrganizations();
      }
    }
  }

  ngOnInit(): void {
       this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
    this.selectedKycDownloadReportType = null;
    this.utilityId = parseInt(localStorage.getItem('utilityId') || '');
    this.currency = localStorage.getItem('currency') || '';
    this.setFilters();
    if (this.hasCimDataIntegration) {
      this.getGeographicalRegions();
    } else {
      this.getRegions();
    }

    if (this.activeTab == 4) {
      this.getOrganizations();
    }

    this.getAllSltStatuses();
    this.getProjectDesignations();
    this.searchTextUpdate.pipe(debounceTime(500)).subscribe((_) => {
      if (this.searchText == '') this.search();
      this.searchFilterApplied = false;
    });
    this.selectedDateType = this.selectedDateType ?? this.dateTypes[0].name;
    this.selectedDateTypeDisplay =
      this.selectedDateTypeDisplay ?? this.dateTypes[0].translation;

    this.selectedSearchType =
      this.selectedSearchType ?? this.searchByOptions[0].name;
    this.selectedSearchTypeDisplay =
      this.selectedSearchTypeDisplay ?? this.searchByOptions[0].translation;

    document.addEventListener('scroll', this.onAnyScroll, true);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.searchTextUpdate.complete();
    document.removeEventListener('scroll', this.onAnyScroll, true);
  }

  private onAnyScroll = (): void => {
    this.showSelectSearchType = false;
    this.showSelectDateType = false;
    this.showSortBy = false;
    this.showDownload = false;
    this.showUpload = false;
    this.showBulkVendorUpload = false;
  };


  private getRoleCapacityRestriction(): InstallationAndPowerSource | null {
    const rolePermissions = localStorage.getItem('permissions');
    const permissions = rolePermissions ? JSON.parse(rolePermissions) : [];
    const hasHigh = permissions.includes(PermissionsEnum.NewService_HighCapacity);
    const hasStandard = permissions.includes(PermissionsEnum.NewService_StandardCapacity);
    if (hasHigh && !hasStandard) return InstallationAndPowerSource.High_Capacity;
    if (!hasHigh && hasStandard) return InstallationAndPowerSource.Standard;
    return null;
  }

  getSltStatusFromRolePermission() {
    const restriction = this.getRoleCapacityRestriction();
    if (restriction == null) return this.selectedSltStatus;
    return this.sltOptions.find(s => s.installationAndPowerSource == restriction)?.id;
  }

  filterSltOptionsByRolePermission(options: typeof this.sltOptions) {
    const restriction = this.getRoleCapacityRestriction();
    if (restriction == null) return options;
    return options.filter(s => s.installationAndPowerSource == restriction);
  }

  openDropdown(which: 'st' | 'dt' | 'sb' | 'dl' | 'ul' | 'bvu', el: HTMLElement): void {
    const wasOpen = which === 'st' ? this.showSelectSearchType
                  : which === 'dt' ? this.showSelectDateType
                  : which === 'sb' ? this.showSortBy
                  : which === 'dl' ? this.showDownload
                  : which === 'ul' ? this.showUpload
                  : this.showBulkVendorUpload;
    this.showSelectSearchType = false;
    this.showSelectDateType = false;
    this.showSortBy = false;
    this.showDownload = false;
    this.showUpload = false;
    this.showBulkVendorUpload = false;
    if (!wasOpen) {
      const r = el.getBoundingClientRect();
      const zoom = parseFloat((getComputedStyle(document.documentElement) as any).zoom || '1');
      this.ddPos = { top: (r.bottom / zoom) + 'px', left: (r.left / zoom) + 'px' };
      if (which === 'st') this.showSelectSearchType = true;
      else if (which === 'dt') this.showSelectDateType = true;
      else if (which === 'sb') this.showSortBy = true;
      else if (which === 'dl') this.showDownload = true;
      else if (which === 'ul') this.showUpload = true;
      else this.showBulkVendorUpload = true;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.downloadWrapper?.nativeElement.contains(event.target)) {
      this.showDownload = false;
    }
    this.showSelectSearchType = false;
    this.showSelectDateType = false;
    this.showSortBy = false;
    this.showUpload = false;
    this.showBulkVendorUpload = false;
  }

  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable();
  }

  selectSltStatus(value: any) {
    if (value != null && value !== '') {
      this.selectedSltStatus = value;
      const isHighCapacity =
        this.sltOptions.find((s) => s.id == this.selectedSltStatus)
          ?.installationAndPowerSource ==
        InstallationAndPowerSource.High_Capacity;
      if (isHighCapacity) {
        this.showSubserviceTypes = true;
      } else {
        this.showSubserviceTypes = false;
        this.selectedSubserviceType = undefined;
      }
    } else {
      this.selectedSltStatus = undefined;
    }
    this.createFilterCards();
  }

  selectSubserviceType(value: any) {
    if (value != null && value !== '') {
      this.selectedSubserviceType = value;
    } else {
      this.selectedSubserviceType = undefined;
    }
    this.createFilterCards();
  }

  selectAssignStatus(value: any) {
    if (value != null && value !== '') {
      this.selectedAssignStatus = value;
    } else {
      this.selectedAssignStatus = undefined;
    }

    this.createFilterCards();
  }

  getAllSltStatuses() {
    this.customerService.getAllSltStatuses().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sltOptions = responseData.data.map((item: any): any => ({
            id: item.id,
            displayValue: item.value,
            installationAndPowerSource:
              InstallationAndPowerSource[
                item.installationAndPowerSource as keyof typeof InstallationAndPowerSource
              ],
          }));
          this.sltOptions = this.filterSltOptionsByRolePermission(this.sltOptions);
          this.selectedSltStatus = this.getSltStatusFromRolePermission();
          this.isSltDropdownDisabled = this.getRoleCapacityRestriction() != null;
          this.getCustomerStats();
          this.getData();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getOrganizations() {
    this.organizationTeamService.getAllForSelect().subscribe({
      next: (response) => {
        this.organizations = response.data.map(
          (item: any) => new OrganizationMultiSelect(item),
        );
        this.setCheckedOrganizations();
      },
      error: (_) =>
        this.toastr.error('Error occurred while fetching organizations'),
    });
  }

  getProjectDesignations() {
    this.projectDesignationService.getAllForSelect(this.utilityId).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.projectDesignations = responseData.data;
          this.setCheckedProjectDesignations();
        }
      },
      error: (_) =>
        this.toastr.error('Error while fetching project designations'),
    });
  }

  setCheckedProjectDesignations() {
    if (!this.selectedProjectDesignationIds?.length) return;
    (this.projectDesignations as any[]).forEach((pd) => {
      pd.checked = this.selectedProjectDesignationIds.includes(pd.id);
    });
    this.createFilterCards();
  }

  setCheckedOrganizations() {
    if (!this.selectedOrganizations?.length) return;
    this.organizations.forEach((org) => {
      org.checked = this.selectedOrganizations.includes(org.id);
    });
    this.createFilterCards();
  }

  selectProjectDesignation(e: any) {
    this.createFilterCards();
  }

  setFilterStorage() {
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count,
      },
      filterParams: this.getFilterObjectForStorage(),
      utilityId: this.utilityId,
    };

    localStorage.setItem('cameFrom', 'ServiceRequestOnboardedCustomers');
    localStorage.setItem(
      'filterServiceRequestOnboardedCustomers',
      JSON.stringify({ type: 'ServiceRequestOnboardedCustomers', filter: obj }),
    );
  }

  getFilterObjectForStorage() {
    let obj = {
      sortBy: this.sortByValue,
      search: this.searchText,
      filterBy: this.filterByValue,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? this.dateTo : null,
      dateType: this.selectedDateType,
      searchType: this.selectedSearchType,
      selectedAreas: this.selectedAreas.length > 0 ? this.selectedAreas : null,
      selectedRegions:
        this.selectedRegions.length > 0 ? this.selectedRegions : null,
      selectedGeographicalRegions:
        this.geographicalRegions.filter((x) => x.checked).map((x) => x.id).length > 0
          ? this.geographicalRegions.filter((x) => x.checked).map((x) => x.id)
          : null,
      selectedSubGeographicalRegions:
        this.selectedSubGeographicalRegions.length > 0
          ? this.selectedSubGeographicalRegions
          : null,
      selectedIds: this.accountKycs
        .filter((x) => x.isChecked == true)
        .map((x) => x.id),
      kycStatus: this.kycStatus ? this.kycStatus : null,
      selectedSltStatus: this.selectedSltStatus ? this.selectedSltStatus : null,
      selectedSubserviceType: this.selectedSubserviceType
        ? this.selectedSubserviceType
        : null,
      kycTag: this.kycTag ? this.kycTag : null,

      selectedProjectDesignationIds:
        this.selectedProjectDesignationIds.length > 0
          ? this.selectedProjectDesignationIds
          : null,
      selectedProjectTypes:
        this.selectedProjectTypes.length > 0 ? this.selectedProjectTypes : null,
      selectedAssignStatus: this.selectedAssignStatus
        ? this.selectedAssignStatus
        : null,
      selectedOrganizations: this.selectedOrganizations
        ? this.selectedOrganizations
        : null,
    };
    return obj;
  }

  checkAllCheckboxes() {
    this.accountKycs.forEach((x) => (x.isChecked = !this.allCheckboxesChecked));
    this.allCheckboxesChecked = !this.allCheckboxesChecked;
  }

  private getData(): void {
    this.reloadTable();
  }

  private getRegions() {
    this.regionService.getAllAssignedForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          this.setCheckedRegions();
          this.getAreas();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getAreas() {
    this.areaService.getAllAssignedForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data;
          this.areas = this.allAreas.filter((area) =>
            this.regions.some(
              (region) => region.id == area.regionId && region.checked,
            ),
          );
          this.setCheckedAreas();
          this.createFilterCards();
          this.removeFilterStorage();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geographicalRegions = responseData.data;
          this.setCheckedGeographicalRegions();
          this.getSubGeographicalRegions();
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeographicalRegions = responseData.data;
          this.subGeographicalRegions = this.allSubGeographicalRegions.filter(
            (sub) =>
              this.geographicalRegions.some(
                (region) =>
                  region.id == sub.geographicalRegion.id && region.checked,
              ),
          );
          this.setCheckedSubGeographicalRegions();
          this.createFilterCards();
          this.removeFilterStorage();
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  removeFilterStorage() {
    if (
      (this.allAreas.length > 0 && this.regions.length > 0) ||
      (this.allSubGeographicalRegions.length > 0 &&
        this.geographicalRegions.length > 0)
    )
      localStorage.removeItem('filterServiceRequestOnboardedCustomers');
  }

  setCheckedAreas() {
    var filter = localStorage.getItem('filterServiceRequestOnboardedCustomers');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'ServiceRequestOnboardedCustomers') return;
    if (filterObject.filter.filterParams.selectedAreas) {
      this.selectedAreas = filterObject.filter.filterParams.selectedAreas;
      this.areas = this.allAreas.filter((area) =>
        this.regions.some(
          (region) => region.id == area.regionId && region.checked,
        ),
      );
      this.areas.forEach((element) => {
        if (this.selectedAreas.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }

  setCheckedRegions() {
    var filter = localStorage.getItem('filterServiceRequestOnboardedCustomers');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'ServiceRequestOnboardedCustomers') return;
    if (filterObject.filter.filterParams.selectedRegions) {
      this.selectedRegions = filterObject.filter.filterParams.selectedRegions;
      this.regions.forEach((element) => {
        if (this.selectedRegions.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }

  setCheckedGeographicalRegions() {
    var filter = localStorage.getItem('filterServiceRequestOnboardedCustomers');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'ServiceRequestOnboardedCustomers') return;
    if (filterObject.filter.filterParams.selectedGeographicalRegions) {
      const selectedIds =
        filterObject.filter.filterParams.selectedGeographicalRegions;
      this.geographicalRegions.forEach((element) => {
        if (selectedIds.includes(element.id)) element.checked = true;
        else element.checked = false;
      });
    }
  }

  setCheckedSubGeographicalRegions() {
    var filter = localStorage.getItem('filterServiceRequestOnboardedCustomers');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'ServiceRequestOnboardedCustomers') return;
    if (filterObject.filter.filterParams.selectedSubGeographicalRegions) {
      this.selectedSubGeographicalRegions =
        filterObject.filter.filterParams.selectedSubGeographicalRegions;
      this.subGeographicalRegions.forEach((element) => {
        if (this.selectedSubGeographicalRegions.includes(element.id as number))
          element.checked = true;
        else element.checked = false;
      });
    }
  }

  setFilters() {
    var filter = localStorage.getItem('filterServiceRequestOnboardedCustomers');
    if (!filter) return;
    var filterObject = JSON.parse(filter);
    if (filterObject.type != 'ServiceRequestOnboardedCustomers') return;
    this.currentPage = filterObject.filter.pageInfo.page;
    this.pageSize = filterObject.filter.pageInfo.pageSize;
    this.count = filterObject.filter.pageInfo.count;
    this.sortByValue = filterObject.filter.filterParams.sortBy;
    this.searchText = filterObject.filter.filterParams.search;
    this.filterByValue = filterObject.filter.filterParams.filterBy;
    this.dateFrom = filterObject.filter.filterParams.dateFrom;
    this.dateTo = filterObject.filter.filterParams.dateTo;
    this.selectedDateType = filterObject.filter.filterParams.dateType;
    this.selectedSearchType = filterObject.filter.filterParams.searchType;
    this.selectedDateTypeDisplay =
      this.dateTypes.find(
        (type) => type.name == filterObject.filter.filterParams.dateType,
      )?.translation ?? this.dateTypes[0].translation;
    this.selectedSearchTypeDisplay =
      this.searchByOptions.find(
        (type) => type.name == filterObject.filter.filterParams.searchType,
      )?.translation ?? this.searchByOptions[0].translation;
    this.selectedAreas = filterObject.filter.filterParams.selectedAreas
      ? filterObject.filter.filterParams.selectedAreas
      : [];
    this.selectedRegions = filterObject.filter.filterParams.selectedRegions
      ? filterObject.filter.filterParams.selectedRegions
      : [];
    this.selectedSubGeographicalRegions = filterObject.filter.filterParams
      .selectedSubGeographicalRegions
      ? filterObject.filter.filterParams.selectedSubGeographicalRegions
      : [];

    this.sortByLabelValue = this.mapSortBy[this.sortByValue];

    this.kycStatus = filterObject.filter.filterParams.kycStatus
      ? filterObject.filter.filterParams.kycStatus
      : undefined;
    this.selectedSltStatus = filterObject.filter.filterParams.selectedSltStatus
      ? filterObject.filter.filterParams.selectedSltStatus
      : undefined;
    this.selectedSubserviceType = filterObject.filter.filterParams
      .selectedSubserviceType
      ? filterObject.filter.filterParams.selectedSubserviceType
      : undefined;
    this.selectedAssignStatus = filterObject.filter.filterParams
      .selectedAssignStatus
      ? filterObject.filter.filterParams.selectedAssignStatus
      : undefined;
    this.kycTag = filterObject.filter.filterParams.kycTag
      ? filterObject.filter.filterParams.kycTag
      : undefined;
    this.selectedProjectDesignationIds =
      filterObject.filter.filterParams.selectedProjectDesignationIds ?? [];
    this.selectedOrganizations = filterObject.filter.filterParams
      .selectedOrganizations
      ? filterObject.filter.filterParams.selectedOrganizations
      : [];

      if (filterObject.filter.filterParams.selectedProjectTypes) {
      this.selectedProjectTypes = filterObject.filter.filterParams.selectedProjectTypes;
      this.projectTypeOptions.forEach((element) => {
        if (this.selectedProjectTypes.includes(element.value)) element.checked = true;
      });
    }
  }

  applySearchFilter(e: any) {
    this.filteredUsers = this.allUsers.filter((user) => user.name.includes(e));
  }

  selectKycStatus(e: any) {
    if (e.target.value != '') {
      this.kycStatus = e.target.value;
    } else {
      this.kycStatus = undefined;
    }
    this.createFilterCards();
  }

  createFilterCards() {
    this.selectedFilters = [];

    this.selectedUsers = this.allUsers
      .filter((x) => x.checked)
      .map((x) => x.id);
    this.selectedRegions = this.regions
      .filter((x) => x.checked)
      .map((x) => x.id);
    if ((this.projectDesignations as any[])?.length > 0) {
      this.selectedProjectDesignationIds = (this.projectDesignations as any[])
        .filter((x) => x.checked)
        .map((x) => x.id);
    }

    let selectedAreas = this.areas.filter((x) => x.checked);
    let selectedGeoRegions = this.geographicalRegions.filter((x) => x.checked);
    let selectedSubGeoRegions = this.subGeographicalRegions.filter(
      (x) => x.checked,
    );

    this.selectedAreas = this.areas.filter((x) => x.checked).map((x) => x.id);
    this.selectedSubGeographicalRegions = this.subGeographicalRegions
      .filter((x) => x.checked)
      .map((x) => x.id as number);

    //geographical regions
    for (var i = 0; i < selectedGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Geographical Region',
          selectedGeoRegions[i].name,
          'COMMON.GEOGRAPHICAL_REGION.SINGLE',
        ),
      );
    }

    //areas
    for (var i = 0; i < selectedAreas.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          this.utName,
          selectedAreas[i].name,
          'COMMON.UT.SINGLE',
        ),
      );
    }

    //sub geographical regions
    for (var i = 0; i < selectedSubGeoRegions.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Sub Geographical Region',
          selectedSubGeoRegions[i].name,
          'COMMON.SUB_GEOGRAPHICAL_REGION.SINGLE',
        ),
      );
    }

    // Service Type
    if (this.selectedSltStatus && !this.isSltDropdownDisabled) {
      var sltStatus = this.sltOptions.find(
        (s) => s.id == this.selectedSltStatus,
      );
      this.selectedFilters.push(
        new ChecklistItem('Service Type', sltStatus!.displayValue),
      );
    }

    if (this.selectedSubserviceType) {
      var subServiceType = this.subServiceTypeOptions.find(
        (s) => s.value == this.selectedSubserviceType,
      );
      this.selectedFilters.push(
        new ChecklistItem('Service Request Type', subServiceType!.displayValue),
      );
    }

    if (this.selectedAssignStatus) {
      var assignStatus = this.assignStatusOptions.find(
        (s) => s.value == this.selectedAssignStatus,
      );
      this.selectedFilters.push(
        new ChecklistItem('Assignment Status', assignStatus!.displayValue),
      );
    }

    if (
      this.kycStatus != null &&
      this.kycStatus !== undefined &&
      this.activeTab != 4
    ) {
      var status = this.kycStatusOptions.find(
        (s) => s.value == Number(this.kycStatus),
      );
      if (status) {
        if (status) {
          this.selectedFilters.push(
            new ChecklistItem(
              'Kyc Status',
              status.name,
              'COMMON.KYC_STATUS_OPTIONS.SINGLE',
              status.translation,
            ),
          );
        }
      }
    }

    if (this.kycTag) {
      var kycTag = this.kycTagOptions.find((s) => s.value == this.kycTag);
      this.selectedFilters.push(new ChecklistItem('Tag', kycTag!.name));
    }

    //search
    if (this.searchText) {
      this.selectedFilters.push(
        new ChecklistItem('Search', this.searchText, 'COMMON.SEARCH'),
      );
    }

    //date from and to
    if (this.dateFrom) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Date From',
          this.dateFrom.toString(),
          'COMMON.DATE_FROM',
        ),
      );
    }

    let selectedProjectTypes = this.projectTypeOptions.filter((x) => x.checked);
    this.selectedProjectTypes = this.projectTypeOptions
      .filter((x) => x.checked)
      .map((x) => x.value);
    for (var i = 0; i < selectedProjectTypes.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Project Status',
          selectedProjectTypes[i].name,
          'NEW_SERVICE.PROJECT_STATUS',
        ),
      );
    }

    let selectedOrganizations = this.organizations.filter((x) => x.checked);

    if (this.organizations?.length > 0) {
      this.selectedOrganizations = this.organizations
        .filter((x) => x.checked)
        .map((x) => x.id);
    }

    for (var i = 0; i < selectedOrganizations.length; i++) {
      this.selectedFilters.push(
        new ChecklistItem(
          'Assigned Vendor',
          selectedOrganizations[i].name!,
          'NEW_SERVICE.ASSIGNED_VENDOR',
        ),
      );
    }

    if (this.dateTo) {
      this.selectedFilters.push(
        new ChecklistItem('Date To', this.dateTo.toString(), 'COMMON.DATE_TO'),
      );
    }

    if (this.activeTab == 4) {
      let selectedProjectDesignations = (
        this.projectDesignations as any[]
      ).filter((x) => x.checked);
      for (var i = 0; i < selectedProjectDesignations.length; i++) {
        this.selectedFilters.push(
          new ChecklistItem(
            'Project Designation',
            selectedProjectDesignations[i].name,
          ),
        );
      }
    }
  }
  selectRegion() {
    //list of areas for selected regions
    this.areas = this.allAreas.filter((area) =>
      this.regions.some(
        (region) => region.id == area.regionId && region.checked,
      ),
    );
    this.allAreas.forEach((area) => {
      if (!this.areas.some((a) => a.id === area.id)) {
        area.checked = false; //uncheck areas for unchecked regions
      }
    });
    this.createFilterCards();
  }

  selectGeographicalRegion() {
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter((sub) =>
      this.geographicalRegions.some(
        (region) => region.id == sub.geographicalRegion.id && region.checked,
      ),
    );
    this.allSubGeographicalRegions.forEach((sub) => {
      if (!this.subGeographicalRegions.some((s) => s.id === sub.id)) {
        sub.checked = false;
      }
    });
    this.createFilterCards();
  }

  selectProjectType() {
    this.createFilterCards();
  }

  selectVendor() {
    this.createFilterCards();
  }

  selectArea() {
    this.createFilterCards();
  }

  removeFilter(item: ChecklistItem) {
    if (item.property == this.buName) {
      this.regions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.selectRegion();
      this.clicked = !this.clicked;
    } else if (item.property == this.utName) {
      this.areas.forEach((area) => {
        if (area.name === item.selectedValue) {
          area.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Service Type') {
      this.selectedSltStatus = undefined;
      this.showSubserviceTypes = false;
      this.selectedSubserviceType = undefined;
    } else if (item.property == 'Service Request Type') {
      this.selectedSubserviceType = undefined;
    } else if (item.property == 'Tag') {
      this.kycTag = undefined;
    } else if (item.property == 'Kyc Status') {
      this.kycStatus = undefined;
    } else if (item.property == 'Search') {
      this.searchText = '';
    } else if (item.property == 'Date From') {
      this.dateFrom = '';
    } else if (item.property == 'Date To') {
      this.dateTo = '';
    } else if (item.property == 'Project Status') {
      this.projectTypeOptions.forEach((pt) => {
        if (pt.name === item.selectedValue) {
          pt.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Project Designation') {
      (this.projectDesignations as any[]).forEach((pd) => {
        if (pd.name === item.selectedValue) {
          pd.checked = false;
        }
      });
    } else if (item.property == 'Assignment Status') {
      this.selectedAssignStatus = undefined;
    } else if (item.property == 'Assigned Vendor') {
      this.organizations.forEach((org) => {
        if (org.name === item.selectedValue) {
          org.checked = false;
        }
      });
      this.clicked = !this.clicked;
    } else if (item.property == 'Geographical Region') {
      this.geographicalRegions.forEach((region) => {
        if (region.name === item.selectedValue) {
          region.checked = false;
        }
      });
      this.selectGeographicalRegion();
      this.clicked = !this.clicked;
    } else if (item.property == 'Sub Geographical Region') {
      this.subGeographicalRegions.forEach((sub) => {
        if (sub.name === item.selectedValue) {
          sub.checked = false;
        }
      });
      this.clicked = !this.clicked;
    }

    this.createFilterCards();

    if (this.selectedFilters.length == 0) {
      this.regions.forEach((region) => {
        region.checked = false;
      });
      this.currentPage = 1;
      this.reloadTable();
      this.getCustomerStats();
    }
  }

  applyRegionFilter() {
    this.getCustomerStats();

    this.reloadTable();
  }

  applyAreaFilter() {
    this.getCustomerStats();

    this.reloadTable();
  }

  sortBy(option: SortByOptions) {
    this.sortByValue = option;
    this.sortByLabelValue = this.mapSortBy[option];

    this.reloadTable();
  }

  selectDateType(dateType: any) {
    this.selectedDateType = dateType.name;
    this.selectedDateTypeDisplay = dateType.translation;
    this.showSelectDateType = false;
  }

  datesValid() {
    if (this.dateFrom && this.dateTo && this.dateTo?.toString() != '') {
      const valid: boolean =
        new Date(this.dateFrom).getTime() <
        new Date(`${this.dateTo.toString()}T23:59:59`).getTime();
      return valid;
    }

    return true;
  }

  selectSearchType(searchType: any) {
    if (this.searchText && this.searchFilterApplied) {
      this.searchText = '';
      this.search();
    }
    this.selectedSearchType = searchType.name;
    this.selectedSearchTypeDisplay = searchType.translation;
    this.showSelectSearchType = false;
  }

  // onFilterBy(option: any) {
  //   if (option === 'New Connection')
  //     this.changeTab(1);
  //   else if (option === 'Onboarded Customers')
  //     this.changeTab(2);
  // }

  resetFilter(reload: boolean = true, removeKycStatus: boolean = true) {
    this.selectedFilters = [];

    this.regions.forEach((region) => (region.checked = false));
    this.areas.forEach((area) => (area.checked = false));
    this.areas = [];
    this.geographicalRegions.forEach((region) => (region.checked = false));
    this.subGeographicalRegions.forEach((sub) => (sub.checked = false));
    this.subGeographicalRegions = [];
    this.selectedAreas = [];
    this.selectedRegions = [];
    this.selectedSubGeographicalRegions = [];
    this.filterByValue = this.filterByOptions.TOTAL;
    this.searchText = '';
    this.dateFrom = '';
    this.dateTo = '';

    this.clicked = !this.clicked;
    this.selectedSltStatus = this.isSltDropdownDisabled ? this.selectedSltStatus : undefined;
    this.selectedSubserviceType = undefined;
    this.kycTag = undefined;
    if (removeKycStatus) this.kycStatus = undefined;

    this.selectedAssignStatus = undefined;
    this.selectedProjectDesignationIds = [];
    (this.projectDesignations as any[]).forEach((pd) => (pd.checked = false));

    this.selectedProjectTypes = [];
    this.selectedOrganizations = [];
    this.projectTypeOptions.forEach((pt) => (pt.checked = false));
    this.organizations.forEach((org) => (org.checked = false));
    this.getCustomerStats();

    if (reload) {
      this.currentPage = 1;
      this.reloadTable();
    }
  }

  reloadTable() {
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count,
      },
      filterParams: this.getKycFilterObject(),
      utilityId: this.utilityId,
    };
    this.getAllKycAccount(obj);
  }

  private getAllKycAccount(obj: any) {
    this.kycAccountService.getAll(obj).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.accountKycs = responseData.data.data;
          this.accountKycs.map(
            (x) =>
              (x.subserviceType = x.subserviceType.replace(
                /([a-z])([A-Z])/g,
                '$1 $2',
              )),
          );
          this.count = responseData.data.count ?? this.count;
          if (responseData.message != '') {
            this.toastr.warning(responseData.message);
          }
        } else if (response?.status == 204) {
          this.toastr.warning('No content');
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }

  search() {
    this.searchFilterApplied = this.searchText ? true : false;
    this.createFilterCards();
  }

  download() {
    var kycObj = this.getKycFilterObject();

    this.kycAccountService.download(kycObj).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 'OK' || data?.status === '200') {
          window.location.href = data.data;
        } else if (data?.status === 'Pending' || data?.status === '600') {
          this.toastr.info(data?.message || '');
        } else this.toastr.error(data?.message || 'Request failed');
      },
      error: (error) => console.log(error),
    });

    this.selectedKycDownloadReportType = undefined;
  }

  getKycFilterObject() {
    let obj = {
      sortBy: this.sortByValue,
      search: this.searchText,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? `${this.dateTo}T23:59:59` : null,
      kycStatus: this.kycStatus
        ? Number(this.kycStatus)
        : this.activeTab == 4
          ? 4
          : null,
      kycTag: this.kycTag ? Number(this.kycTag) : null,
      selectedAreas: this.selectedAreas.length > 0 ? this.selectedAreas : null,
      selectedRegions:
        this.selectedRegions.length > 0 ? this.selectedRegions : null,
      selectedSubGeographicalIds:
        this.selectedSubGeographicalRegions.length > 0
          ? this.selectedSubGeographicalRegions
          : null,
      selectedIds: this.accountKycs
        .filter((x) => x.isChecked == true)
        .map((x) => x.id),
      selectedSltStatus: this.selectedSltStatus
        ? Number(this.selectedSltStatus)
        : null,
      selectedSubserviceType: this.selectedSubserviceType
        ? Number(this.selectedSubserviceType)
        : null,
      kycDownloadReportType: this.selectedKycDownloadReportType,

      searchType: this.selectedSearchType,
      selectedProjectDesignations:
        this.selectedProjectDesignationIds.length > 0
          ? this.selectedProjectDesignationIds
          : null,
      selectedAssignStatus: this.selectedAssignStatus
        ? Number(this.selectedAssignStatus)
        : null,
      selectedOrganizations:
        this.selectedOrganizations.length > 0
          ? this.selectedOrganizations
          : null,
      selectedProjectTypes:
        this.selectedProjectTypes.length > 0 ? this.selectedProjectTypes : null,
    };
    return obj;
  }

  applyFilter() {
    this.currentPage = 1;
    this.reloadTable();
  }

  private getCustomerStats() {
    var obj = this.getKycFilterObject();
    this.customerStats = new NewServiceStats();
    this.getOnboardedStats(obj);
  }

  private getOnboardedStats(obj: any) {
    var filter = {
      filter: obj,
      Option: CustomerStatsOptions.Onboarded,
    };
    this.customerService.getOnboardedCustomersStats(filter).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.customerStats.newConnection = data.data.newConnection;
          this.customerStats.onboardedCustomers = data.data.onboardedCustomers;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectKycTag(e: any) {
    if (e.target.value != '') {
      this.kycTag = e.target.value;
    } else {
      this.kycTag = undefined;
    }
    this.createFilterCards();
  }
}
